import { render, staticRenderFns } from "./HomeCategories.vue?vue&type=template&id=7897b248&scoped=true&"
var script = {}
import style0 from "./HomeCategories.vue?vue&type=style&index=0&id=7897b248&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7897b248",
  null
  
)

export default component.exports